import React, { useEffect, useState } from "react";
import Maincomponent from "../../Components/Maincomponent/Maincomponent";
import { Input } from "antd";
import { useParams } from "react-router-dom";
import * as xlsx from "xlsx";
import Apiurl from "../../Apiurl";
import { Tabhelper } from "../../Helper/Tabhelper";
import { Button, Modal, Form, Table } from "react-bootstrap";
import Basedatatemplate from "../../Templates/Basedata_template.xlsx";
import axios from "axios";

export default function Basedata_upload() {
  const [jsonList, setJsonList] = useState([]);

  const apiurl = Apiurl();
  const { user } = useParams();

  const [file, setFile] = useState();
  const [data, setdata] = useState([]);

  // LABEL → DB FIELD MAP
  const fieldMap = {
    "District": "district",
    "School Name": "school_name",
    "Student_name": "student_name",
    "Gender": "gender",
    "Class": "student_class",
    "Father Name": "father_name",
    "Address": "address",
    "Street Name": "street_name",
    "Area": "area",
    "Village": "village",
    "Pincode": "pincode",
    "Phone 1": "phone_1",
    "Phone 2": "phone_2",
    "Medium": "medium",
    "Year": "year",
    "Source": "source",
  };

  const requiredFields = Object.keys(fieldMap);

  const [excelColumns, setExcelColumns] = useState([]);
  const [mappings, setMappings] = useState({});
  const [showModal, setShowModal] = useState(false);

  const convertDate = (excelDate) => {
    if (!excelDate) return null;

    const date = new Date(excelDate);
    if (isNaN(date)) return null;

    return date.toISOString().split("T")[0];
  };

  const handleSubmit = async () => {
    const mappedRows = data.map((row) => {
      let obj = {};

      requiredFields.forEach((label) => {
        const backendKey = fieldMap[label];
        const excelCol = mappings[label];

        let value = excelCol ? row[excelCol] : "";

        if (backendKey === "entry_date") {
          value = convertDate(value);
        }

        obj[backendKey] = value || "";
      });

      // extra fields required by backend
      obj["status"] = "Base";
      obj["remarks"] = "";

      return obj;
    });

    try {
      await axios.post(apiurl + "bulkbasedata/", mappedRows);
      alert("Base Data uploaded successfully");
      setShowModal(false);
    } catch (error) {
      console.error(error);
      alert("Some Error occurred\nTry again Later");
    }
  };

  const readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
      setFile(e.target.files[0]);
      const reader = new FileReader();
      reader.onload = (e) => {
        const buffer = e.target.result;
        const workbook = xlsx.read(buffer, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = xlsx.utils.sheet_to_json(worksheet);
        setdata(json);

        const columns = Object.keys(json[0] || {});
        setExcelColumns(columns);

        setShowModal(true);
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const initialData = {
    name: "Base Data Upload",
    link: "/basedata_upload",
    active: "no",
  };

  const handleDownload = () => {
    const filePath = Basedatatemplate;
    const link = document.createElement("a");
    link.href = filePath;
    link.setAttribute("download", "basedata_template.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    Tabhelper(initialData, setJsonList);
  }, []);

  return (
    <Maincomponent tabname={"Base Data Upload"}>
      <div className="component-sub">
        <div className="component-sub1">
          <div className="multistephead">
            <b>BASE DATA UPLOAD</b>
          </div>

          <br />

          <div className="Billcompmain">
            <div className="Billcompmain2">
              <div className="multistepcontainer1">
                <div className="multistepsubcontainer1">
                  <div className="multisteptable">
                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">File</div>
                      <div className="multisteptablecell2">
                        <Input type="file" onChange={readUploadFile} className="textipbill" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {data.length > 0 && (
                <b>Total Rows: {data.length}</b>
              )}

              <div className="multistepcontainerbtn">
                <Button variant="success" size="sm" onClick={handleDownload}>
                  Template
                </Button>

                {data.length > 0 && (
                  <button className="buttoncompnent1" onClick={() => setShowModal(true)}>
                    Map Data
                  </button>
                )}
              </div>
            </div>
          </div>

          <br /><br />

          <div className="Billcompmain">
            {data.length > 0 ? (
              <Table bordered striped hover size="sm">
                <thead>
                  <tr>
                    {Object.keys(data[0]).map((col) => (
                      <th key={col}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, idx) => (
                    <tr key={idx}>
                      {Object.keys(row).map((col) => (
                        <td key={col}>{row[col]}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p>No data uploaded.</p>
            )}
          </div>
        </div>
      </div>

      {/* ===================== MAPPING MODAL ====================== */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Map Excel Columns</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
          {requiredFields.map((label) => (
            <div key={label} className="d-flex mb-3" style={{ gap: "10px" }}>
              <div style={{ width: "45%", fontWeight: "bold" }}>{label}</div>
              <div style={{ width: "55%" }}>
                <Form.Select
                  value={mappings[label] || ""}
                  onChange={(e) =>
                    setMappings({ ...mappings, [label]: e.target.value })
                  }
                >
                  <option value="">-- Select Excel Column --</option>
                  {excelColumns.map((col) => (
                    <option key={col} value={col}>{col}</option>
                  ))}
                </Form.Select>
              </div>
            </div>
          ))}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>

          <Button variant="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </Maincomponent>
  );
}
